// Wraps a task surface with right-click context menu support outside TaskItemBase.
import { cloneElement, isValidElement } from 'react';
import TaskContextMenu from '@/features/tasks/components/context-menu/TaskContextMenu';
import { useTaskItemContextMenu } from '@/features/tasks/components/context-menu/useTaskItemContextMenu';

/**
 * @param {object} props
 * @param {import('@/types').Task} props.task
 * @param {import('@/features/tasks/components/context-menu/taskContextMenuConfig').TaskContextMenuSurface} props.surface
 * @param {import('react').ReactElement} props.children
 * @param {(parentId: string) => void} [props.onStartAddingSubtask]
 */
export default function TaskContextMenuTarget({
  task,
  surface,
  children,
  onStartAddingSubtask,
}) {
  const { menuState, handleContextMenu, closeMenu } = useTaskItemContextMenu({
    menuSurface: surface,
  });

  const child = isValidElement(children)
    ? cloneElement(children, {
        onContextMenu: (event) => {
          children.props.onContextMenu?.(event);
          handleContextMenu(task, event);
        },
      })
    : children;

  return (
    <>
      {child}
      {menuState ? (
        <TaskContextMenu
          task={menuState.task}
          surface={surface}
          anchorPosition={{
            mouseX: menuState.mouseX,
            mouseY: menuState.mouseY,
          }}
          open
          onClose={closeMenu}
          onStartAddingSubtask={onStartAddingSubtask}
        />
      ) : null}
    </>
  );
}
